import { combineReducers } from "@reduxjs/toolkit";
import certificateReducer from '../redux/features/certificate/certificateSlice';
import lookupReducer from '../redux/features/lookup/lookupSlice';

const appReducer = combineReducers({
    certificate: certificateReducer,
    lookup: lookupReducer,
});

const rootReducer = (state, action) => {
  if (
    action.type === "auth/signOut/fulfilled" ||
    action.type === "auth/signOut/rejected"
  ) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
